type ThemeOption = {
  id: string;
  name: string;
};

type PartialThemeOption = {
  id?: string | null;
  name?: string | null;
};

export const withCurrentTheme = (
  themes: readonly ThemeOption[] | undefined,
  currentTheme: PartialThemeOption | null | undefined,
): ThemeOption[] => {
  const list = themes ?? [];

  if (
    currentTheme?.id == null ||
    currentTheme.name == null ||
    list.some(theme => theme.id === currentTheme.id)
  ) {
    return [...list];
  }

  return [...list, { id: currentTheme.id, name: currentTheme.name }];
};
